import { render, staticRenderFns } from "./AppInstallPopup.vue?vue&type=template&id=0e65a39a&scoped=true"
import script from "./AppInstallPopup.vue?vue&type=script&lang=js"
export * from "./AppInstallPopup.vue?vue&type=script&lang=js"
import style0 from "./AppInstallPopup.vue?vue&type=style&index=0&id=0e65a39a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65a39a",
  null
  
)

export default component.exports